import React, { Component } from 'react'
import { Route } from 'react-router-dom'
import * as routes from '../../constants/routes'
import { firebase, db } from '../../firebase'
import moment from 'moment'
import { Offline, Online } from 'react-detect-offline'

import withAuthorization from '../Session/withAuthorization'
import { NavigationWithRouter as Navigation, NavigationSmallerWithRouter as NavigationSmaller } from '../Navigation'
import Home from '../Home'
import Outline from '../Outline'
import Bores from '../Bores'
import Maintenance from '../Maintenance'
import Prestarts from '../Prestarts'
import Profile from '../Profile'
import Timesheets from '../Timesheets'
import ExplosiveInv from '../ExplosiveInv'
import Calendar from '../Calendar'
import FulcrumRoute from '../FulcrumRoute'
import { buildBoreList, refreshFulcrumData, subscribeFulcrumLoaded } from '../../utilities/fulcrumData'

import Dev from '../Dev'

import './index.css'
import { Layout, message, Icon, Tooltip } from 'antd'
import 'antd/dist/antd.css'

const { Content, Footer } = Layout

class ClientPortal extends Component {
  constructor() {
    super()
    this.state = {
      user: {
        id: '',
        username: '',
        role: '',
        email: ''
      },
      width: '',
      lastLoaded: <Icon type='loading' />
    }
  }
  componentDidMount() {
    if (firebase.auth.currentUser) {
      db.getCurrentUsername(firebase.auth.currentUser.uid)
        .then(snapshot => {
          var idFound = snapshot.key
          var usernameFound = snapshot.child('username').val()
          var roleFound = snapshot.child('role').val()
          var emailFound = snapshot.child('email').val()
          this.setState({
            user: {
              id: idFound,
              username: usernameFound,
              role: roleFound,
              email: emailFound
            }
          })
          db.lastActive(idFound, moment().format('Do MMMM YYYY, h:mm:ss a'))
        })
        .catch(err => message.error('There has been an error loading user data. Please be patient. Error: ' + err, 10))
    }
    this.interval = setInterval(() => this.handleRefreshData(), 600000)
    this.unsubscribeLoaded = subscribeFulcrumLoaded(() => {
      this.setState({ lastLoaded: moment().format('LT') })
    })
    window.addEventListener('resize', this.updateDimensions)
  }
  updateDimensions = () => {
    this.setState({ width: window.innerWidth })
  }
  componentWillMount() {
    this.updateDimensions()
  }
  componentWillUnmount() {
    clearInterval(this.interval)
    if (this.unsubscribeLoaded) {
      this.unsubscribeLoaded()
    }
    window.removeEventListener('resize', this.updateDimensions)
  }

  handleRefreshData = (evt) => {
    if (evt === 'Button Refresh') {
      message.loading('Loading Fulcrum data..', 2.5)
    }

    refreshFulcrumData()

    this.setState({ lastLoaded: moment().format('LT') })

    if (this.state.user.id) {
      db.lastActive(this.state.user.id, moment().format('Do MMMM YYYY, h:mm:ss a'))
    }

    if (evt === 'Button Refresh') {
      message.success('Data is up to date.')
    }
  }

  printFormat(location) {
    if (window.location.hash.includes('timesheets')) {
      if (location === 'header') {
        return (
          <div className='showThisPrint'>
            <h1>Drilltec Pty Ltd</h1>
          </div>
        )
      }
      if (location === 'footer') {
        return (
          <div className='showThisPrint' style={{ marginTop: 20 }}>
            <h1 style={{ float: 'left' }}>QPpf-7-7</h1>
            <h1 style={{ float: 'right' }}>{moment().format('LLLL')}</h1>
          </div>
        )
      }
    }
  }
  render() {
    const { user, width, lastLoaded } = this.state

    function navigationBased(width, user) {
      if (width >= 992) {
        return <Navigation user={user} />
      } else if (width <= 991) {
        return <NavigationSmaller user={user} />
      }
    }

    return (
      <Layout>
        {navigationBased(width, user)}
        <Layout className='layoutContent'>
          <Online>
            <Tooltip title='Data loads automatically after 10 minutes.' mouseEnterDelay={2} placement='bottom'>
              <div id='lastLoaded' onClick={() => this.handleRefreshData('Button Refresh')} className='printHide'>
                <span id='lastLoadedDefault'>Data Last Loaded {lastLoaded}</span>
                <span id='lastLoadedRefreash'>Click to Refresh Data</span>
              </div>
            </Tooltip>
          </Online>
          <Offline>
            <div id='lastLoaded'>
              <span style={{ color: '#e74c3c', fontWeight: 600 }}>No Internet Connection</span>
            </div>
          </Offline>
          <Content style={{ margin: '24px 16px 0', minHeight: '89vh' }}>
            <div className="pageContent" style={{ padding: 24, background: '#fff', height: '100%' }}>
              {this.printFormat('header')}
              <Route
                exact
                path={routes.CLIENTPORTAL}
                render={props => (
                  <FulcrumRoute datasets={['Posts', 'QualityPlans']}>
                    {({ Posts, QualityPlans }) => (
                      <Home {...props} user={user} posts={Posts} QualityPlans={QualityPlans} />
                    )}
                  </FulcrumRoute>
                )}
              />
              <Route
                path={routes.OUTLINE}
                render={props => (
                  <FulcrumRoute datasets={['QualityPlans']}>
                    {({ QualityPlans }) => (
                      <Outline {...props} QualityPlans={QualityPlans} user={user} />
                    )}
                  </FulcrumRoute>
                )}
              />
              <Route
                path={routes.BORES}
                render={props => (
                  <FulcrumRoute datasets={['QualityPlans']}>
                    {({ QualityPlans }) => (
                      <Bores
                        {...props}
                        user={user}
                        QualityPlans={QualityPlans}
                        boreList={buildBoreList(QualityPlans, user)}
                      />
                    )}
                  </FulcrumRoute>
                )}
              />
              <Route
                path={routes.CALENDAR}
                render={props => (
                  <FulcrumRoute datasets={['Calendar', 'QualityPlans']}>
                    {({ Calendar: calendarEvents, QualityPlans }) => (
                      <Calendar
                        {...props}
                        user={user}
                        events={calendarEvents}
                        QualityPlans={QualityPlans}
                      />
                    )}
                  </FulcrumRoute>
                )}
              />
              <Route path={routes.MAINTENANCE} render={props => <Maintenance {...props} />} />
              <Route path={routes.PRESTARTS} render={props => <Prestarts {...props} />} />
              <Route
                path={routes.TIMESHEETS}
                render={props => (
                  <FulcrumRoute datasets={['Timesheets']}>
                    {({ Timesheets: timesheets }) => (
                      <Timesheets {...props} user={user} timesheets={timesheets} />
                    )}
                  </FulcrumRoute>
                )}
              />
              <Route path={routes.PROFILE} render={props => <Profile {...props} user={user} />} />
              <Route
                path={routes.EXPLOSIVEINV}
                render={props => (
                  <FulcrumRoute datasets={['Explosives']}>
                    {({ Explosives }) => (
                      <ExplosiveInv {...props} user={user} explosives={Explosives} />
                    )}
                  </FulcrumRoute>
                )}
              />
              <Route
                path={routes.DEVELOPER}
                render={props => (
                  <FulcrumRoute datasets={['QualityPlans']}>
                    {({ QualityPlans }) => (
                      <Dev {...props} user={user} QualityPlans={QualityPlans} />
                    )}
                  </FulcrumRoute>
                )}
              />
              {this.printFormat('footer')}
            </div>
          </Content>
          <Footer style={{ textAlign: 'center', background: '#f3f3f3' }} className='printHide'>
            <a href="https://www.jialx.com" style={{ color: 'inherit' }}>Built by Jim</a>
          </Footer>
        </Layout>
      </Layout>
    )
  }
}
const authCondition = authUser => !!authUser

export default withAuthorization(authCondition)(ClientPortal)
